export default __webpack_public_path__ + "static/media/logo-dark.936a18e8.png";